import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { xhr } from '@shared/config';
import { useAppDispatch, useAppSelector } from '@shared/hooks';
import {
  closeSupportModal,
  openNotifyModal,
  openSupportModal,
  selectSupportOpen,
} from '@src/library/redux/modal';
import { schema, type Form } from './lib';

export const useSupportForm = () => {
  const dispatch = useAppDispatch();

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Form>({ resolver: yupResolver(schema) });
  const navigate = useNavigate();
  const onSubmit = async (data: Form) => {
    try {
      const response = await xhr.post(`/api/v1/feedbacks/`, {
        subject: data.subject,
        comment: data.comment,
      });
      if (!response.data) {
        throw response;
      }
      reset();
      dispatch(
        openNotifyModal({
          title: 'Уведомление',
          needClose: true,
          text: 'Спасибо за обращение, мы свяжемся с вами в самое ближайшее время',
          confirm: () => navigate(-1),
          confirmText: 'Готово',
        })
      );
      dispatch(closeSupportModal());
    } catch (error) {
      dispatch(
        openNotifyModal({
          title: 'Ошибка',
          text: 'Не удалось отправить сообщение',
          confirmText: 'Ок',
        })
      );
    }
  };
  return {
    control,
    register,
    errors,
    submit: handleSubmit(onSubmit),
  };
};

export const useSupportModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectSupportOpen);

  const openSupport = () => dispatch(openSupportModal());

  const closeSupport = () => dispatch(closeSupportModal());
  return {
    isOpen,
    openSupport,
    closeSupport,
  };
};
